import { useEffect, useRef } from "react";
import { Stack } from "@chakra-ui/react";
import { redirect } from "react-router-dom";

import { RoutesMap } from "../../routes.tsx";
import { Logo } from "../../components/shared/Logo";
import { useSbpTransferStore } from "../../store/sbpTransferStore.ts";
import { SbpTransferResultPageContent } from "../../components/features/SbpTransfer";

export const SbpTransferResultPage = () => {
  const setTransferResult = useSbpTransferStore(state => state.setTransferResult);
  const mountedRef = useRef(false);

  useEffect(() => {
    mountedRef.current = true;

    return () => {
      mountedRef.current = false;
      setTimeout(() => {
        if (!mountedRef.current) {
          setTransferResult(null);
        }
      }, 0);
    };
  }, [setTransferResult]);

  return (
    <Stack spacing={0} h="100svh" pt="17px" alignItems="center">
      <Logo />

      <SbpTransferResultPageContent />
    </Stack>
  );
};

SbpTransferResultPage.loader = () => {
  const { transferResult } = useSbpTransferStore.getState();

  if (!transferResult?.status) {
    return redirect(RoutesMap.index);
  }

  return null;
};
